import { Box, Typography } from "@mui/material";
import React from "react";
import {
    keyDetailsItemContainer,
    keyDetailsItemLabel,
    keyDetailsItemValue,
} from "./keyDetailsItemStyles";

interface KeyDetailsItemProps {
    label: string;
    value: string;
}

const KeyDetailsItem: React.FC<KeyDetailsItemProps> = ({ label, value }) => {
    return (
        <Box sx={keyDetailsItemContainer}>
            <Typography variant="body2" sx={keyDetailsItemLabel}>
                {label}
            </Typography>
            <Typography variant="h6" sx={keyDetailsItemValue}>
                {value}
            </Typography>
        </Box>
    );
};

export default KeyDetailsItem;
